import React, { useState, useMemo, useEffect, useRef } from "react";
import Layout from "../../layout/Layout";
import CardSlider from "../../section/EarningSection/CardSlider";
import JobTable, { StatusPill } from "../../table/JobTable";
import OptionInput from "../../input/optionInput/OptionInput";
import Dialog from "../../dialog/Dialog";
import TextInput from "../../input/TextField/TextInput";
import useDashboard from "../../../customHooks/useDashboard";
import { BASE_URL_2 } from "../../../customHooks/config";
import axios from "axios";
import { toast } from "react-toastify";
import UserTimerInfo from "../../card/earning/UserTimerInfo";
import {
  ArrowUpTrayIcon,
  PaperClipIcon,
  PlusIcon,
  XMarkIcon,
  CloudArrowUpIcon,
} from "@heroicons/react/24/outline";
import { InformationCircleIcon } from "@heroicons/react/24/solid";
import Spinner from "../../layout/loader/Spinner";
import InterviewKitDialog from "../../section/JobSection/InterviewKitDialog";

function Earning() {
  // const [stages, setStages] = useState([]);
  // const data = useMemo(() => getData(), []);
  const [open, setOpen] = useState(false);
  const [myEarning] = useDashboard();
  const [amount, setAmount] = useState(null);
  const [rows, setRows] = useState([]);
  const id = 2;
  const [filter, setFilter] = useState({});
  const [data, setData] = useState([]);
  const [prefill, setPrefill] = useState(false);
  const [requestRaised, setRequestRaised] = useState(false);
  const [requestRaisedMessage, setRequestRaisedMessage] = useState(null);
  const [loadingRequest, setLoadingRequest] = useState(false);
  const [paginationData, setPaginationData] = useState({
    pageSize: 5,
    pageNumber: 1,
    next: false,
    previous: false,
    count: 0,
  });
  const [loading, setLoading] = useState(false);
  const [interviewKitData, setInterviewKitData] = useState(null);
  const [interviewKitLoadingStates, setInterviewKitLoadingStates] = useState({});

  const handleClickScore = (params) => {
    if (params?.total_weightage !== null && params?.total_weightage !== undefined) {
      setInterviewKitLoadingStates((prev) => ({ ...prev, [params.id]: true }));
      axios
        .get(`${BASE_URL_2}job/vendor/applicant_interview_kit_response/?job_applicant_id=${params.id}`, {
          withCredentials: true,
        })
        .then((res) => {
          if (res?.data?.success && res?.data?.data) {
            setInterviewKitData(res?.data?.data);
          } else {
            toast.error("No interview kit data available");
          }
          setInterviewKitLoadingStates((prev) => ({ ...prev, [params.id]: false }));
        })
        .catch((err) => {
          toast.error(err?.data?.error || "Failed to fetch interview kit response");
          setInterviewKitLoadingStates((prev) => ({ ...prev, [params.id]: false }));
        });
    }
  };

  const handleInterviewKitDialogClose = () => setInterviewKitData(null);

  const handleChangeAmount = (e) => {
    setAmount(e.target.value);
  };

  const validation = () => {
    let error = false;
    if (amount === null || amount === 0 || amount === "undefined" || amount < 100 || amount > 5000) {
      error = true;
      toast.error("Please Enter Amount in  Withdrawn limit greater then ₹100 and less then ₹5,000")
    } else if (!file) {
      error = true;
      toast.error("Please Select the Invoice")
    }
    return error;
  };

  const handleRaiseRequest = () => {
    if (!validation()) {
      const form = new FormData();
      form.append("amount", amount);
      form.append("file", file);
      setLoadingRequest(true);
      axios
        .post(`${BASE_URL_2}job/vendor/raised_request/`, form, {
          withCredentials: true,
        })
        .then((res) => {
          setLoadingRequest(false);
          if (res?.data?.success) {
            toast.success(res?.data?.data?.message);
            setRequestRaisedMessage(res?.data?.data?.message);
            setRequestRaised(true);
            handleClose();
          } else toast.error(res?.data?.data?.message);
        })
        .catch((err) => {
          toast.error(err?.data?.error);
          setLoadingRequest(false);
        });
    }
  };

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const DialogActions = (btnColor) => {
    return (
      <>
        {" "}
        <div className="grid grid-cols-2 gap-4 px-8 py-7 pt-2 ">
          <div>
            <button
              type="button"
              className="w-full text-[#6C757D] border border-[#6C757D] rounded-md h-[40px]"
              onClick={handleClose}
            >
              Cancel
            </button>
          </div>
          <div>
            <button
              type="button"
              className="w-full text-white rounded-md bg-[#2563EB] h-[40px] "
              onClick={handleRaiseRequest}
            >
              {loadingRequest ? <Spinner /> : "Raise Request"}
            </button>
          </div>
        </div>
      </>
    );
  };
  const columns = useMemo(
    () => [
      {
        Header: "Job ID",
        width: 60,
        accessor: "job_id",
      },
      {
        Header: "Job Title",
        width: 150,
        accessor: "job_title",
      },
      {
        Header: "Company Name",
        width: 160,
        accessor: "company_name",
      },
      {
        Header: "Candidate Name",
        width: 130,
        accessor: "candidate_name",
      },

      {
        Header: "Mobile number",
        width: 120,
        accessor: "phone",
      },
      {
        Header: "Email id",
        width: 130,
        accessor: "email",
      },
      {
        Header: "Joined Date",
        width: 100,
        accessor: "joined_date",
      },

      {
        Header: "Stages",
        width: 130,
        Cell: ({ row }) => (
          <>
            <StatusPill value={row.original.status_name} />
          </>
        ),
        accessor: "stages",
      },
      {
        Header: "Interview Score",
        width: 110,
        Cell: ({ row }) => (
          row.original.total_weightage !== null && row.original.total_weightage !== undefined ? (
            <span className="inline-block px-3 py-1 rounded-full text-sm font-bold border border-[#22c55e] text-[#22c55e] bg-green-50">
              {row.original.total_weightage} pts
            </span>
          ) : (
            <span className="text-gray-400 text-sm">-</span>
          )
        ),
        accessor: "score",
      },
      {
        Header: "Interview  Response",
        width: 120,
        Cell: ({ row }) => (
          row.original.total_weightage !== null && row.original.total_weightage !== undefined ? (
            <button
              className="h-[34px] px-3 bg-white border border-[#2563EB] rounded-md text-sm text-[#2563EB] hover:bg-blue-50"
              onClick={() => handleClickScore(row.original)}
            >
              {interviewKitLoadingStates[row.original.id] ? <Spinner /> : "View"}
            </button>
          ) : (
            <span className="text-gray-400 text-sm">-</span>
          )
        ),
        accessor: "kit_response",
      },
    ],
    [interviewKitLoadingStates]
  );

  useEffect(() => {
    setLoading(true);
    let url = `${BASE_URL_2}job/vendor/candidate_info/?page_size=${paginationData?.pageSize}&page=${paginationData?.pageNumber}`;
    if (filter?.stages?.param)
      url = `${BASE_URL_2}job/vendor/candidate_info/?page_size=${paginationData?.pageSize}&page=${paginationData?.pageNumber}${filter?.stages?.param}`;

    axios
      .get(url, { withCredentials: true })
      .then((res) => {
        const nums = res?.data?.data;
        setRows(nums?.results);
        setPaginationData({
          ...paginationData,
          count: nums?.count,
          next: nums?.next ? true : false,
          previous: nums?.previous ? true : false,
        });
        setLoading(false);
      })
      .catch((err) => {
        toast.error(err?.data?.error);
        setLoading(false);
      });
  }, [paginationData.pageNumber, paginationData.pageSize, filter]);

  useEffect(() => {
    axios
      .get(`${BASE_URL_2}job/vendor/job_stages/`, { withCredentials: true })
      .then((res) => {
        const arr = [];
        for (const [key, value] of Object.entries(res?.data?.data)) {
          arr.push(value);
        }
        setData(arr);
      })
      .catch((err) => {
        toast.error(err?.data?.error);
      });
  }, []);

  useEffect(() => {
    axios
      .get(`${BASE_URL_2}job/vendor/job_stages`, { withCredentials: true })
      .then((res) => {
        const arr = [];
        for (const [key, value] of Object.entries(res?.data?.data)) {
          arr.push(value);
        }
        setData(arr);
      })
      .catch((err) => {
        toast.error(err?.data?.error);
      });
  }, []);

  const [timeLeft, setTimeLeft] = useState(null);

  useEffect(() => {
    if (timeLeft === 0) {
      setTimeLeft(null);
    }
    if (!timeLeft) return;
    const intervalId = setInterval(() => {
      setTimeLeft(timeLeft - 1);
    }, 1000);

    return () => clearInterval(intervalId);
  }, [timeLeft]);

  const inputRef = useRef(null);
  const [file, setFile] = useState(null);

  const handleFile = (e) => {
    const res = e.target.files[0];
    setFile(res);
  };
  const handleRemoveFile = () => {
    setFile(null);
    setPrefill(false);
  };

  return (
    // <Layout>
    <div className="w-full">
      <div className="relative">
        <div className="py-4">
          <h2 className="text-lg font-semibold ">Earning information</h2>
        </div>
        <CardSlider
          earning={myEarning}
          handleClickOpen={handleClickOpen}
          requestRaised={requestRaised}
          requestRaisedMessage={requestRaisedMessage}
        />
      </div>


      <>
        <div className="mt-4" >
          <UserTimerInfo />
        </div>
      </>


      <div className=" w-full flex  flex-col relative mt-8 z-10">
        <div className=" w-full flex justify-between items-center">
          <div className="mr-4">
            <h2 className="text-lg  font-bold ">Candidate information</h2>
          </div>
          <div className="w-[200px]">
            <OptionInput
              placeholder="Stages"
              data={data}
              filter={filter}
              setFilter={setFilter}
            />
          </div>
        </div>
        <div className="mt-2">
          <JobTable
            columns={columns}
            data={rows}
            tableWidth="w-full"
            paginationData={paginationData}
            setPaginationData={setPaginationData}
            loading={loading}
            pagination="pagination"
          />
        </div>
      </div>

      <InterviewKitDialog
        selectedRowData={interviewKitData}
        handleDialogClose={handleInterviewKitDialogClose}
      />

      <div>
        <Dialog
          visible={open}
          title={"Enter your amount"}
          handleCloseDialog={handleClose}
          actionsPannel={DialogActions("bg-green")}
          size={"w-2/7"}
          color={"bg-green"}
        >
          <div className=" h-fit w-[350px]">
            <div>
              <TextInput
                placeholder="Amount"
                onChange={handleChangeAmount}
                value={amount}
              />
              <p className="text-xs  text-[#6C757D] italic mt-[-10px]">
                Note: Withdrawn limit greater then ₹100 and less then ₹5,000 {" "}
              </p>
              <div className="mt-5">
                {file ? (
                  <p className=" text-lg font-semibold">Invoice uploaded</p>
                ) : (
                  ""
                )}
                <div className="flex items-center justify-center w-full mt-1 ">
                  <label
                    for="dropzone-file"
                    style={{ height: file ? "60px" : "230px" }}
                    className="flex flex-col items-center justify-center w-full  border-2 border-gray-300 border-dashed rounded-lg cursor-pointer bg-[#f8fafc]  hover:bg-gray-100 "
                  >
                    <div
                      className="items-center  w-full "
                      style={{
                        display: "flex",
                        flexDirection: file ? "row" : "column",
                        justifyContent: file ? "space-between" : "center",
                        paddingLeft: "5%",
                        paddingRight: "5%",
                      }}
                    >
                      <div>
                        <input
                          ref={inputRef}
                          type="file"
                          onChange={handleFile}
                          className="hidden"
                          accept=".doc,.docx,.pdf"
                        />
                        <p className="text-xs text-[#6C757D]">
                          {file ? (
                            <p className="text-xs font-bold  text-black flex ">
                              <PaperClipIcon className="h-4 w-4 text-[#6C757D] mr-2 " />
                              {file?.name}
                            </p>
                          ) : (
                            <>
                              <div className="flex flex-col items-center mt-2 text-center ">
                                <CloudArrowUpIcon className="w-8 h-8 mb-2 text-black " />
                                <div className="flex items-center mt-1 mb-2">
                                  <p className="text-sm text-black">
                                    Upload your invoice document
                                  </p>
                                  <InformationCircleIcon className="h-4 w-4 text-black ml-1 " />
                                </div>
                                {prefill
                                  ? "Last Uploaded"
                                  : "Accepts .pdf, .doc and .docx"}
                              </div>
                            </>
                          )}
                        </p>
                      </div>
                      <div>
                        {!file && !prefill ? (
                          <button
                            onClick={() => {
                              inputRef.current.click();
                            }}
                            className="border border-[#2563EB] text-[#2563EB] mt-4 h-[35px] text-sm  rounded-md px-3 font-normal flex items-center "
                          >
                            Select file
                          </button>
                        ) : (
                          <button
                            onClick={handleRemoveFile}
                            className="bg-[#2563EB] rounded-full h-[30px] w-[30px] flex justify-center items-center "
                          >
                            <XMarkIcon className="h-4 w-4 text-white " />
                          </button>
                        )}
                      </div>
                    </div>
                  </label>
                  {/* <div className="border border-1 mt-3 bg-white border-[#CBD5E1] p-4 rounded-lg flex justify-between  items-center "> */}
                </div>
              </div>
            </div>
          </div>
        </Dialog>
      </div>
    </div>
    // </Layout>
  );
}

export default Earning;
